import PropTypes from 'prop-types';

import SMSTierDialogWithOrderSummaryV2 from '../SMSTierDialogWithOrderSummaryV2';

const SMSTierDialogWithOrderSummary = (props) => {
  return <SMSTierDialogWithOrderSummaryV2 {...props} />;
};

SMSTierDialogWithOrderSummary.defaultProps = {
  smsPurchasedCallback: null,
  closeOnSuccess: false,
};

SMSTierDialogWithOrderSummary.propTypes = {
  open: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  closeOnSuccess: PropTypes.bool,
  smsPurchasedCallback: PropTypes.func,
};

export default SMSTierDialogWithOrderSummary;
